module.exports = __webpack_public_path__ + "img/45.3bf7c27b.jpg";